var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-wrapper",class:{ 'mobile-editor': _vm.isMobile }},[_c('div',{staticClass:"wang-editor-container",attrs:{"id":_vm.editorId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }